import ssc from './ssc';
import xyrb from './xyrb';
import pk10 from './pk10';
import ks from './ks';
import three from './three';
import choose5 from './choose5';
import hpten from './hpten'
export default (type, gameType, Vue) => {
  if (type == 'ssc') {
    return ssc;
  }
  if (type == 'xyrb') {
    return xyrb;
  }
  if (type == 'PK10' || type == 'nn') {
    return pk10;
  }
  if (type == 'ks') {
    return ks;
  }
  if (type == 'three') {
    return three(gameType);
  }
  if (type == 'choose5') {
    return choose5;
  }
  if (type == 'hpten') {
    return hpten
  }
};



// WEBPACK FOOTER //
// ./src/pages/Trend/History/columns/index.js